import { FC, useEffect, useState } from 'react';
import SortedTable from '../sorted-table/SortedTable';
import { InventoryTrans } from '../../types/interfaces/transaction.interfaces';
import { getShippingOrderDetailsByBulkId } from '../../api/shippingOrderDetailApi';
import { centsToDollars } from '../../services/account.service';
import { showToast } from '../../services/toast.service';
import { TABLE_HEADER_CONSTANTS } from '../../constants/common';
import { toastMessages } from '../../constants/errorMessages';
import './linkedTransactions.scss';

interface ShippingDetailsProps {
  inventoryTransaction: InventoryTrans;
}

const ShippingDetails: FC<ShippingDetailsProps> = ({ inventoryTransaction }): JSX.Element => {
  const [shippingOrderDetail, setShippingOrderDetail] = useState<any>();

  useEffect(() => {
    const fetchShippingOrderDetail = async () => {
      if (inventoryTransaction.bulkOrderId) {
        try {
          const res = await getShippingOrderDetailsByBulkId({ bulkOrderId: inventoryTransaction.bulkOrderId });
          setShippingOrderDetail(res.data);
        } catch {
          showToast.error(toastMessages.SOMETHING_WENT_WRONG);
        }
      }
    };
    fetchShippingOrderDetail();
  }, [inventoryTransaction.bulkOrderId]);

  const totalShippingCostCents = inventoryTransaction.shippingPaymentTransaction.reduce(
    (sum: number, txn: any) => sum + (txn?.shippingOutBoundCostCents ?? 0) + (txn?.shippingReturnCostCents ?? 0),
    0,
  );

  const totalInsurancePremiumCents = inventoryTransaction.shippingPaymentTransaction.reduce(
    (sum: number, txn: any) => sum + (txn?.insurancePremiumCents ?? 0),
    0,
  );

  const tableHeaders = [
    { displayName: TABLE_HEADER_CONSTANTS.SHIPPING_ORDER_ID },
    { displayName: TABLE_HEADER_CONSTANTS.SHIPPING_COST },
    { displayName: TABLE_HEADER_CONSTANTS.INSURANCE_PREMIUM },
    { displayName: TABLE_HEADER_CONSTANTS.SHIPMENT_ID },
    { displayName: TABLE_HEADER_CONSTANTS.TRACKING_NUMBER },
  ];

  return (
    <div className="shipping-details">
      <div className="desk-shipping-details">
        <SortedTable
          headers={tableHeaders}
          data={[
            [
              { content: shippingOrderDetail?.orderId ?? '-' },
              { content: `$${centsToDollars(totalShippingCostCents)}` },
              { content: `$${centsToDollars(totalInsurancePremiumCents)}` },
              { content: shippingOrderDetail?.shippingLabelInformation?.outBoundLabelInfo?.shipmentId ?? '-' },
              { content: shippingOrderDetail?.shippingLabelInformation?.outBoundLabelInfo?.trackingNumber ?? '-' },
            ],
          ]}
        />
      </div>

      {/** Mobile View */}
      <div className="xs-shipping-details">
        <div className="card max-width" key={'shipping-detail' + inventoryTransaction.inventoryTransactionId}>
          <div className="shipping-details-content">
            <div className="transaction-info">
              <div className="transaction-content">
                <label>{TABLE_HEADER_CONSTANTS.SHIPPING_ORDER_ID} :</label>
                <label>{`${shippingOrderDetail?.orderId ?? '-'}`}</label>
              </div>
              <div className="transaction-content">
                <label>{TABLE_HEADER_CONSTANTS.SHIPPING_COST} :</label>
                <label>{`$${centsToDollars(totalShippingCostCents)}`}</label>
              </div>
            </div>
            <div className="transaction-info">
              <div className="transaction-content">
                <label>{TABLE_HEADER_CONSTANTS.INSURANCE_PREMIUM} :</label>
                <label>{`$${centsToDollars(totalInsurancePremiumCents)}`}</label>
              </div>
              <div className="transaction-content">
                <label>{TABLE_HEADER_CONSTANTS.SHIPMENT_ID} :</label>
                <label>{`${shippingOrderDetail?.shippingLabelInformation?.outBoundLabelInfo?.shipmentId ?? '-'}`}</label>
              </div>
              <div className="transaction-content">
                <label>{TABLE_HEADER_CONSTANTS.TRACKING_NUMBER} :</label>
                <label>{`${shippingOrderDetail?.shippingLabelInformation?.outBoundLabelInfo?.trackingNumber ?? '-'}`}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingDetails;
